import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

import { StartpageModule } from './types';
import { RootModule } from '../root-module';

const namespaced = true;

export const state = {
  projects: [],
  searchstring: '',
};

export const startpage: Module<StartpageModule, RootModule> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
